import CommonBreadCrumbs from "@/components/common/bread-crumbs"
import CommonButtonGoTo from "@/components/common/button-go-to"
import { getTemplatedMetaArray } from "@/utils/getTemplatedMetaArray"
import type { MetaFunction } from "react-router"

export const meta: MetaFunction = ({ matches }) => {
  return getTemplatedMetaArray(matches, {
    title: "404 NOT FOUND | コタエルHR",
    description: "お探しのページは見つかりませんでした。",
  })
}

/** In Remix, wildcard route is called "splat routes" */
export default function SplatRoutes() {
  const breadcrumbs = [
    { name: "HOME", url: "/" },
    {
      name: "404 NOT FOUND",
      url: "",
    },
  ]

  return (
    <>
      <main
        id="top"
        className={`
          px-10 pt-20 pb-0
          min-h-[calc(100vh-250px)]
          max-w-[880px]
          mx-auto my-0
          flex items-center justify-start
        `}
      >
        <div className="px-0 pt-14 pb-24 flex flex-col gap-7">
          <h1 className="text-[18px] md:text-[32px]">404 NOT FOUND</h1>
          <p className="text-[12px] md:text-[18px] leading-5">
            お探しのページは見つかりませんでした。
            <br />
            移動または削除された可能性があります。
          </p>
          <CommonButtonGoTo text="トップページ" to="/" />
        </div>
      </main>
      <CommonBreadCrumbs items={breadcrumbs} />
    </>
  )
}
